import { AssetPreloader } from "../../utils/AssetPreloader";

class Preloader{

    element;
    span1;
    span2;

    
    TESTING=false

    constructor(){
        if (window.debug){
            this.TESTING=true;
        }
        document.addEventListener('DOMContentLoaded',()=>{
            this.initLoad();
        })
    }

    initLoad(){
        this.element=document.querySelector('.loader');
        this.span1=this.element.querySelector('.logo-loader--1');
        this.span2=this.element.querySelector('.logo-loader--2');

        let preloaderFiles=[
            BasePath+"/public/img/ui/entrada_140x140px_97fts_3-3seg.png",
            BasePath+"/public/img/ui/loop_140x140px_39fts_3-1seg.png"
        ]


        let t1=(this.TESTING)?100:1000;
        let t2=(this.TESTING)?100:3300;

        AssetPreloader.preloadFiles(preloaderFiles,()=>{},()=>{
            this.span1.classList.add('logo-loader--in');
            setTimeout(() => {
                this.span2.classList.add('logo-loader--loop');
                setTimeout(() => {
                    this.preloadFiles();
                }, t1);
                
            }, t2);
        },()=>{

        })
    }

    preloadFiles(){
        let f=[];
        f.push(BasePath+'/public/js/libs.min.js')
        f.push(BasePath+'/public/js/main.min.js')
        
        AssetPreloader.preloadFiles(f,()=>{},()=>{
        },()=>{
            console.log("LOAD ERROR");
        })

    }

}
export {Preloader}